import React from "react";
import _ from "underscore";
import { connect } from "react-redux";
import { fetchDecisionAids } from "../actions/appActions";
import Chapters from "./chapter/Chapters";
import Header from "./Header";
import Spinner from "./common/Spinner";
import appStyles from "../styles/app.module.scss";
import styles from "../styles/decisionAids.module.scss";

class DecisionAid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      doc: null,
      isFetching: false
    };
  }

  componentDidMount() {
    const { projectId, documentId, timestamp } = this.props.match.params;
    this.props.dispatch(fetchDecisionAids(projectId, documentId, timestamp));
  }

  componentDidUpdate(prevProps) {
    const { params: currentParams } = this.props.match;
    const { params: prevParams } = prevProps.match;

    if (!_.isEqual(prevParams, currentParams)) {
      const { projectId, documentId, timestamp } = currentParams;
      this.props.dispatch(fetchDecisionAids(projectId, documentId, timestamp));
    }
  }

  render() {
    const { doc, isFetching, error } = this.props;
    if (isFetching) return <Spinner />;
    if (!_.isEmpty(error))
      return <div className={appStyles.globalError}>{error.message}</div>;
    if (_.isEmpty(doc)) return null;
    const { chapters, chaptersOrder, question } = doc;
    const { theme, illustration } = doc.appearance;
    return (
      <div>
        <Header title={doc.title} theme={theme} illustration={illustration} />
        <div className={styles.decisionAids}>
          <Chapters
            chapters={chapters}
            chaptersOrder={chaptersOrder}
            question={question}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.isFetching,
  doc: state.doc,
  error: state.error
});

export default connect(mapStateToProps)(DecisionAid);
